import billingApiModule from '../billingApi.module';

class BillingConfigurationApiService {
    constructor(__env, $q, apiUtil, authenticationConstants, httpUtil) {
        this.__env = __env;
        this.$q = $q;
        this.apiUtil = apiUtil;
        this.authenticationConstants = authenticationConstants;
        this.httpUtil = httpUtil;
    }

    getJsUrls() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/config/resources/js`
        );
    }

    getPaymentMethodConfiguration() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/config/payment-methods`
        );
    }

    getPaymentMethodFormConfiguration(formId) {
        if (!formId) {
            return this.$q.reject();
        }

        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${
                this.__env.billingApiUrl
            }/api/v1/config/payment-methods/forms/${formId}`
        );
    }

    getUpcomingChargesConfiguration() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/config/billing-preview/list`
        );
    }

    getInvoicesConfiguration() {
        return this.apiUtil.getWithBearerAuth(
            this.authenticationConstants.billing.name,
            `${this.__env.billingApiUrl}/api/v1/config/invoices/list`
        );
    }

    getGuestAccessConfiguration() {
        return this.httpUtil.get(
            `${this.__env.billingApiUrl}/api/v1/config/guest-access`
        );
    }
}

export default billingApiModule.service(
    'billingConfigurationApiService',
    BillingConfigurationApiService
);



// WEBPACK FOOTER //
// ./modules/billingApi/configuration/billingConfigurationApi.service.js